import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { landingData } from "../../../Utils/Apis";

export const useLanding = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const {
    post,
    state: { mainData },
  } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(landingData);
    if (+status == 200) {
      setData(data);
    }
    setLoading(false);
  };
  useEffect(() => {
    getData();
  }, []);

  return {
    data,
    loading,
    mainData,
  };
};
